import React from 'react'
import PropTypes from 'prop-types'
import { IconSLI60Wrapper } from './IconSLI60Wrapper'

export const Icon60FileCode = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLI60Wrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 36 47.94'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M36.001,13.984 C36.001,14.019 35.984,14.049 35.981,14.083 L35.981,45.908 C35.981,47.022 35.072,47.931 33.956,47.931 L2.037,47.931 C0.913,47.931 -0.000,47.018 -0.000,45.896 L-0.000,2.041 C-0.000,0.918 0.913,0.006 2.037,0.006 L21.988,0.006 C22.033,0.006 22.072,0.026 22.116,0.032 C22.161,0.038 22.200,0.046 22.244,0.058 C22.414,0.104 22.573,0.177 22.694,0.298 C22.694,0.298 22.694,0.298 22.695,0.298 L35.579,13.169 C35.611,13.192 35.626,13.230 35.655,13.256 C35.684,13.283 35.707,13.313 35.732,13.344 C35.887,13.519 36.001,13.731 36.001,13.984 ZM2.000,1.939 L1.999,45.896 L34.000,45.940 L34.000,14.939 L22.000,14.939 C21.448,14.939 20.989,14.535 20.989,13.984 L20.989,1.939 L2.000,1.939 ZM22.988,3.415 L22.988,12.986 L32.568,12.986 L22.988,3.415 ZM14.699,37.653 C14.504,37.849 14.248,37.946 13.992,37.946 C13.737,37.946 13.481,37.849 13.286,37.653 L7.289,31.662 C6.898,31.273 6.898,30.641 7.289,30.251 L13.286,24.260 C13.676,23.871 14.308,23.871 14.699,24.260 C15.089,24.651 15.089,25.282 14.699,25.672 L9.409,30.957 L14.699,36.241 C15.089,36.632 15.089,37.263 14.699,37.653 ZM21.281,24.263 C21.672,23.872 22.304,23.872 22.695,24.263 L28.692,30.253 C29.082,30.644 29.082,31.275 28.692,31.665 L22.695,37.655 C22.500,37.851 22.244,37.948 21.988,37.948 C21.732,37.948 21.477,37.851 21.281,37.655 C20.891,37.266 20.891,36.634 21.281,36.244 L26.572,30.959 L21.281,25.674 C20.891,25.285 20.891,24.653 21.281,24.263 Z'
        />
      </svg>
    </IconSLI60Wrapper>
  )
}

Icon60FileCode.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
